import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const initialFormData = {
  firstName: '',
  lastName: '',
  classGrade: '',
  schoolName: '',
  email: '',
  phone: '',
  website_url: '' // Honeypot
};

const generateId = () => {
  return typeof crypto !== 'undefined' && crypto.randomUUID 
    ? crypto.randomUUID() 
    : Math.random().toString(36).substring(2, 15) + Date.now().toString(36);
};

export const useRegistrationStore = create(
  persist(
    (set) => ({
      formData: initialFormData,
      idempotencyKey: generateId(), // Safe generation
      
      updateFormData: (newData) => set((state) => ({
        formData: { ...state.formData, ...newData },
        idempotencyKey: generateId() // Generate fresh key when payload changes
      })),
      
      resetForm: () => set(() => ({
        formData: initialFormData,
        idempotencyKey: generateId() // Generate fresh key for next time
      })),
      
      regenerateIdempotencyKey: () => set(() => ({
        idempotencyKey: generateId()
      }))
    }),
    {
      name: 'registration-form-storage', // unique name in localStorage
    }
  )
);

// Feature 2: Cross-Tab State Synchronization
// Listens for localStorage changes from other tabs and instantly syncs state
if (typeof window !== 'undefined') {
  window.addEventListener('storage', (e) => {
    if (e.key === 'registration-form-storage') {
      useRegistrationStore.persist.rehydrate();
    }
  });
}
